import React from "react";
import styles from "./EntityCard.module.scss";

/**
 * Kart görünümünde tek bir entity'i temsil eder — task, project, client,
 * lead, vb.
 *
 *   <EntityCard
 *     density="comfortable"   // "compact" (list-2 modu) | "comfortable" (grid-3/4)
 *     onClick={...}
 *     logo={<img src=...>}    // opsiyonel — marka logosu (projeler için)
 *     icon={<Folder />}       // opsiyonel — logo yoksa kategori ikonu
 *     title="..."
 *     subtitle="..."           // örn. müşteri adı
 *     meta={[                  // opsiyonel — etiket/değer listesi
 *       { label: "Status", value: <StatusPill ... /> },
 *       { label: "Deadline", value: "21-08-2025" },
 *     ]}
 *     tags={<LabelChipsRow ... />}  // alt etiket satırı
 *     footer={<Avatars />}     // sağ alt köşe — atanan kişiler, vs.
 *     actions={<IconButton .../>}   // sağ üst — 3-nokta veya yıldız
 *     accentColor="blue"       // sol kenar accent (cal- renk anahtarı)
 *   />
 */
const EntityCard = ({
  as: Tag = "article",
  onClick,
  density = "comfortable",
  logo,
  icon,
  title,
  subtitle,
  meta,
  tags,
  footer,
  actions,
  accentColor,
  children,
  ariaLabel,
}) => {
  const interactive = !!onClick;
  const handleKey = (e) => {
    if (!interactive) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick(e);
    }
  };

  return (
    <Tag
      className={styles.card}
      data-density={density}
      data-interactive={interactive || undefined}
      data-accent={accentColor || undefined}
      onClick={interactive ? onClick : undefined}
      onKeyDown={interactive ? handleKey : undefined}
      role={interactive ? "button" : undefined}
      tabIndex={interactive ? 0 : undefined}
      aria-label={ariaLabel || title}
    >
      <header className={styles.head}>
        <div className={styles.headLeft}>
          {logo ? (
            <span className={styles.logo}>{logo}</span>
          ) : icon ? (
            <span className={styles.icon}>{icon}</span>
          ) : null}
          <div className={styles.heading}>
            {title ? <h3 className={styles.title}>{title}</h3> : null}
            {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
          </div>
        </div>
        {actions ? <div className={styles.actions}>{actions}</div> : null}
      </header>

      {children ? <div className={styles.body}>{children}</div> : null}

      {meta && meta.length > 0 ? (
        <dl className={styles.meta}>
          {meta.map((m, i) => (
            <div key={`${m.label}-${i}`} className={styles.metaRow}>
              <dt className={styles.metaLabel}>{m.label}</dt>
              <dd className={styles.metaValue}>{m.value}</dd>
            </div>
          ))}
        </dl>
      ) : null}

      {tags ? <div className={styles.tags}>{tags}</div> : null}

      {footer ? <footer className={styles.footer}>{footer}</footer> : null}
    </Tag>
  );
};

export default EntityCard;
